import { useGetOne } from 'react-admin';

const useLocation = (id: number) => useGetOne('Location', { id }, { enabled: !!id });

export default useLocation;
